"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusAwayService = void 0;
const index_1 = require("./index");
class FocusAwayService {
    constructor() {
        this.__priority = 100;
        this.events = [];
    }
    init() {
        index_1.Services.Window.window.addEventListener('mousedown', (evt) => this.runMouse(evt, index_1.Services.Window.window));
    }
    from(element, callback) {
        const existingEvent = this.events.find((e) => e.element === element);
        if (existingEvent) {
            existingEvent.callback = callback;
            return;
        }
        const newEvent = {
            element,
            callback,
        };
        this.events.push(newEvent);
    }
    runMouse(evt, win) {
        if (this.events.length === 0) {
            return;
        }
        this.purgeEvents(win);
        this.events
            .filter((focusAwayEvent) => !focusAwayEvent.element.contains(evt.target))
            .forEach((focusAwayEvent) => focusAwayEvent.callback.call(null));
    }
    drop(element, callback) {
        this.events = this.events.filter((e) => !(e.element === element && e.callback === callback));
    }
    dropByElement(element) {
        this.events = this.events.filter((e) => !(e.element === element));
    }
    purgeEvents(win) {
        this.events = this.events.filter((focusAwayEvent) => win.document.contains(focusAwayEvent.element));
    }
}
exports.FocusAwayService = FocusAwayService;
//# sourceMappingURL=focus.away.service.js.map